import React from 'react';
import { Link } from 'react-router-dom';

export default function AdminBlogHeader({ title, subtitle, onSave, saving, showPreview, onTogglePreview, backTo = '/adminblog/posts' }) {
  return (
    <header className="adminblog-header">
      <div className="adminblog-header-left">
        <Link to={backTo} className="adminblog-back-link">← Back</Link>
        <div className="adminblog-header-title">
          <h1>{title || 'Blog Admin'}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
      <div className="adminblog-header-right">
        {onTogglePreview && (
          <button
            className={`adminblog-preview-btn ${showPreview ? 'active' : ''}`}
            onClick={onTogglePreview}
          >
            {showPreview ? 'Hide Preview' : 'Preview'}
          </button>
        )}
        {onSave && (
          <button
            className="adminblog-save-btn"
            onClick={onSave}
            disabled={saving}
          >
            {saving ? 'Saving...' : 'Save'}
          </button>
        )}
      </div>
    </header>
  );
}
